import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_ZIPCODE_INTERNACIONAL_" }
);

export interface CreateZipcodeInternacionalState extends IState {}

const INITIAL_STATE: CreateZipcodeInternacionalState = {
  loading: false,
  error: null,
};

const request = (state: CreateZipcodeInternacionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreateZipcodeInternacionalState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CreateZipcodeInternacionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createZipcodeInternacional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateZipcodeInternacionalTypes = Types;
export const CreateZipcodeInternacionalActions = Creators;
